import React, { Component } from 'react';
import fastMemoize from 'fast-memoize';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import StyledReactTable from 'components/molecules/StyledReactTable';
import Pagination from 'components/molecules/tables/components/Pagination';
import CellDiv from 'components/molecules/tables/components/CellDiv';

const DEFAULT_PAGE_SIZE = 25;

class EntityUsersTable extends Component {
    constructor(props) {
        super(props);

        this.formatUsers = fastMemoize(EntityUsersTable.formatUsers);
        this.userTableInstance = React.createRef();

        const headerStyle = {
            textAlign: 'left'
        };

        this.columns = [{
            dataField: 'fullName',
            text: 'Name',
            formatter: this.viewUserLink,
            headerStyle,
            sort: true
        }, {
            dataField: 'email',
            text: 'Email',
            headerStyle,
            sort: true
        }];
    }

    static formatUsers(users) {
        return users.map(user => ({ fullName: `${user.firstName} ${user.lastName}`, ...user }));
    }

    getColumns() {
        return [
            {
                Header: 'NAME',
                Cell: props => this.viewUserLink(null, props.original),
                accessor: 'fullName'
            }, {
                Header: 'EMAIL',
                accessor: 'email',
                Cell: row => <CellDiv value={row.value} />,
            }
        ];
    }

    viewUserLink(cell, row) {
        return (
            <Link to={`/admin/users/${row.id}/edit`} title="Go to User">
                {row.fullName}
            </Link>
        );
    }

    render() {
        const formattedUsers = this.formatUsers(this.props.data);
        const showPagination = !!(formattedUsers.length > DEFAULT_PAGE_SIZE);

        return <StyledReactTable
            data={formattedUsers}
            ref={this.userTableInstance}
            defaultPageSize={DEFAULT_PAGE_SIZE}
            minRows={1}
            getTheadThProps={() => ({
                style: {
                    backgroundColor: '#E2E2E2',
                }
            })}
            getTheadFilterThProps={() => ({
                style: {
                    overflow: 'inherit' // allows react-select to work
                }
            })}
            columns={this.getColumns()}
            defaultSorted={[{
                id: 'fullName', desc: false
            }]}
            className="-highlight"
            showPagination={showPagination}
            PaginationComponent={Pagination}
        />;
    }
}

EntityUsersTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
    })).isRequired
};

export default EntityUsersTable;



// WEBPACK FOOTER //
// ./src/components/molecules/tables/EntityUsersTable.js